import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MenuModel, ProfileInfoModel } from '@app/core/Models';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(private http: HttpClient) {}

  getMenu(): Observable<Array<MenuModel>> {
    return this.http.get<Array<MenuModel>>(
      `${environment.apiVersionUrl}ModuleRolePermission/user`
    );
  }

  getProfileInfo(): Observable<ProfileInfoModel> {
    return this.http.get<ProfileInfoModel>(`${environment.apiVersionUrl}user`);
  }

  getAddMenu(): Observable<Array<MenuModel>> {
    return this.http.get<Array<MenuModel>>(
      `${environment.apiVersionUrl}ModuleRolePermission/addModules`
    );
  }
}
